/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import React from 'react';
import { ToastContainer } from 'react-toastify';

export const Notification = () => <ToastContainer position="top-center" hideProgressBar={true} />;
